export const BOOK_LAUNCHED = "book/launched";
